<template>
  <v-scale-screen :width="1280" :height="680" :auto-scale="{ x: true, y: true }">
    <div id="productionReport" ref="appRef">
      <div class="bg">
        <dv-loading v-if="loading">Loading...</dv-loading>
        <div v-else class="host-body">
          <div class="header-box">
            <div class="d-flex jc-center project-title">
              医用织物智慧数据管理中心
            </div>
            <div class="d-flex jc-center project-title project-box">
              <div class="project-sub-title">
                荣获国家高新技术企业、深圳专精特新企业双授牌
              </div>
            </div>
            <div class="header-right">
              <div class="top-date">
                <span class="text"
                  >{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span
                >
              </div>
              <div class="custom-seamless">
                <div class="text">让科技赋能健康医疗服务，助力医院降本增效</div>
              </div>
            </div>
          </div>

          <div class="content-box">
            <div class="page-title">租洗生产报表</div>

            <!-- 骞存湀Tab鍒囨崲鍜屽勾浠介€夋嫨鍣?-->
            <div class="date-controls">
              <div class="tab-switch">
                <span
                  :class="['tab-item', { active: dateType === 'month' }]"
                  @click="switchDateType('month')"
                >
                  月度
                </span>
                <span
                  :class="['tab-item', { active: dateType === 'year' }]"
                  @click="switchDateType('year')"
                >
                  年度
                </span>
              </div>

              <div class="year-selector">
                <span class="selector-label">{{
                  dateType === "year" ? "选择年份：" : "选择年月："
                }}</span>
                <el-date-picker
                  v-model="selectedYear"
                  :type="dateType === 'year' ? 'year' : 'month'"
                  :placeholder="dateType === 'year' ? '选择年份' : '选择月份'"
                  :clearable="false"
                  :editable="false"
                  @change="handleDateChange"
                />
              </div>
            </div>

            <div class="data-container">
              <div v-if="loading" class="loading-box">
                <dv-loading>加载中...</dv-loading>
              </div>
              <div v-else>
                <el-table
                  v-if="tableData.length > 0"
                  :data="tableData"
                  stripe
                  border
                  show-summary
                  :summary-method="getSummary"
                >
                  <el-table-column
                    prop="statDate"
                    label="日期"
                    width="105"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ formatDateHeader(scope.row.statDate) }}
                    </template>
                  </el-table-column>

                  <el-table-column
                    v-for="hospital in hospitalColumns"
                    :key="hospital.customerId || hospital.customerName"
                    :prop="hospital.customerName"
                    :label="hospital.customerName"
                    min-width="120"
                    align="center"
                  />

                  <el-table-column
                    prop="rowTotal"
                    label="合计"
                    width="105"
                    align="center"
                  />
                </el-table>

                <div v-if="tableData.length === 0" class="empty-tip">
                  暂无数据
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-scale-screen>
</template>

<script>
import { formatTime } from "../utils/index.js";
import * as api from "@/api/index";

export default {
  name: "ProductionReport",
  data() {
    return {
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      dateType: "month",
      selectedYear: new Date(),
      hospitalColumns: [],
      tableData: [],
      hospitalTotals: {},
      grandTotal: 0,
      timing: null,
    };
  },
  mounted() {
    this.initData();
    this.timeFn();
    this.cancelLoading();
  },
  beforeDestroy() {
    if (this.timing) {
      clearInterval(this.timing);
    }
  },
  methods: {
    async initData() {
      await this.fetchData();
    },
    async fetchData() {
      const year = new Date(this.selectedYear).getFullYear();
      const month = new Date(this.selectedYear).getMonth() + 1;

      if (year < 2024) {
        this.$message.warning("请选择 2024 年及之后");
        this.tableData = [];
        this.hospitalColumns = [];
        return;
      }

      if (this.dateType === "month" && year === 2024 && month < 5) {
        this.$message.warning("月度报表仅支持 2024-05 及之后");
        this.tableData = [];
        this.hospitalColumns = [];
        return;
      }

      let startDate;
      let endDate;
      if (this.dateType === "year") {
        startDate = `${year}-01-01`;
        endDate = `${year}-12-31`;
      } else {
        const days = this.getMonthDays(year, month);
        const mm = String(month).padStart(2, "0");
        startDate = `${year}-${mm}-01`;
        endDate = `${year}-${mm}-${String(days).padStart(2, "0")}`;
      }

      try {
        const res = await api.getBigSkuCustomerCash({
          startDate,
          endDate,
          dateType: this.dateType,
        });

        if (res.ResultCode !== 0) {
          this.$message.error("获取数据失败");
          return;
        }

        this.processData(res.Result || []);
      } catch (error) {
        console.error("获取数据失败:", error);
        this.$message.error("获取数据失败");
      }
    },
    processData(data) {
      if (!data || data.length === 0) {
        this.tableData = [];
        this.hospitalColumns = [];
        this.hospitalTotals = {};
        this.grandTotal = 0;
        return;
      }

      const hospitalSet = new Set();
      const hospitalMap = {};

      data.forEach((item) => {
        const customerName = item.customerName || "未知医院";
        hospitalSet.add(customerName);
        if (!hospitalMap[customerName]) {
          hospitalMap[customerName] = {
            customerId: item.customerId,
            customerName,
          };
        }
      });

      this.hospitalColumns = Array.from(hospitalSet)
        .sort()
        .map((name) => hospitalMap[name]);

      const dateMap = {};
      data.forEach((item) => {
        const statDate = item.statDate;
        const customerName = item.customerName || "未知医院";

        if (!dateMap[statDate]) {
          dateMap[statDate] = {
            statDate,
            data: {},
            rowTotal: 0,
          };
        }

        const value = item.numReceive || 0;
        dateMap[statDate].data[customerName] = value;
        dateMap[statDate][customerName] = value;
        dateMap[statDate].rowTotal += value;
      });

      this.tableData = Object.values(dateMap).sort((a, b) =>
        a.statDate.localeCompare(b.statDate)
      );

      this.hospitalTotals = {};
      this.hospitalColumns.forEach((hospital) => {
        let total = 0;
        this.tableData.forEach((row) => {
          total += row.data[hospital.customerName] || 0;
        });
        this.hospitalTotals[hospital.customerName] = total;
      });

      this.grandTotal = Object.values(this.hospitalTotals).reduce(
        (sum, val) => sum + val,
        0
      );
    },
    formatDateHeader(date) {
      if (!date) return "";
      if (this.dateType === "year") {
        const month = parseInt(date.split("-")[1], 10);
        return `${month}月`;
      }
      const day = parseInt(date.split("-")[2], 10);
      return `${day}日`;
    },
    switchDateType(type) {
      this.dateType = type;
      this.fetchData();
    },
    handleDateChange() {
      this.fetchData();
    },
    getMonthDays(year, month) {
      const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (month === 2 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0)) {
        return 29;
      }
      return daysInMonth[month - 1];
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), "HH: mm: ss");
        this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    cellStyle() {
      return {
        background: "rgb(0, 10, 45)",
      };
    },
    getSummary(param) {
      const { columns } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === columns.length - 1) {
          sums[index] = this.grandTotal;
          return;
        }
        const hospitalName = column.property;
        sums[index] = this.hospitalTotals[hospitalName] || 0;
      });

      return sums;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/index.scss";

#productionReport {
  width: 100%;
  height: 100%;
  background: url("../assets/images/bg.jpg") no-repeat center center;
  background-size: 100% 100%;

  .bg {
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
  }

  .host-body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .header-box {
    position: relative;
    width: 100%;
    // height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    flex-direction: column;

    .project-title {
      font-size: 32px;
      font-weight: bold;
      color: #00cdff;
      text-shadow: 0 0 10px rgba(0, 205, 255, 0.8);
    }

    .project-box {
      // position: absolute;
      top: 45px;
      width: 400px;
      overflow: hidden;
    }

    .project-sub-title {
      padding-top: 50px;
      font-size: 18px;
      color: #00cdff;
      animation: scroll-left 20s linear infinite;
      white-space: nowrap;

      // 灞忓箷楂樺害杈冨皬鏃讹紝padding-top 杈冨皬
      @media screen and (max-height: 700px) {
        padding-top: 30px;
      }

      @media screen and (min-height: 701px) and (max-height: 900px) {
        padding-top: 40px;
      }

      @media screen and (min-height: 901px) {
        padding-top: 70px;
      }
    }

    .header-right {
      position: absolute;
      right: 20px;
      top: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 10px;

      .top-date {
        color: #00cdff;
        font-size: 14px;
      }

      .custom-seamless {
        overflow: hidden;

        .text {
          color: #00cdff;
          font-size: 14px;
          animation: scroll-left 20s linear infinite;
          white-space: nowrap;
        }
      }
    }
  }

  @keyframes scroll-left {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  .content-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0 20px;
    overflow: hidden;

    .page-title {
      padding-top: 50px;
      font-size: 24px;
      font-weight: bold;
      color: #00cdff;
      text-align: center;
      margin-bottom: 20px;
    }

    // 年月 Tab 切换
    .date-controls {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }

    .tab-switch {
      display: flex;
      justify-content: center;

      .tab-item {
        padding: 10px 30px;
        font-size: 16px;
        color: #8e9eae;
        cursor: pointer;
        transition: all 0.3s;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);

        &:first-child {
          border-radius: 4px 0 0 4px;
        }
        &:last-child {
          border-radius: 0 4px 4px 0;
        }
        &:hover {
          color: #fff;
        }
        &.active {
          background: #409eff;
          color: #fff;
          border-color: #409eff;
        }
      }
    }

    .year-selector {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-left: 20px;
      .selector-label {
        color: #fff;
        font-size: 16px;
        margin-right: 10px;
      }

      ::v-deep .el-date-editor {
        width: 150px;
        .el-input__inner {
          background: rgba(255, 255, 255, 0.1);
          border-color: rgba(255, 255, 255, 0.3);
          color: #fff;
        }
      }
    }

    .data-container {
      // flex: 1;
      // min-height: 0;
      // background: rgba(0, 0, 0, 0.3);
      border-radius: 10px 10px 0 0;
      padding: 20px;
      overflow: auto;
      // margin-bottom: 20px;
      // display: flex;
      // flex-direction: column;

      .loading-box {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .empty-tip {
        text-align: center;
        padding: 40px 0;
        color: #8e9eae;
        font-size: 14px;
      }
    }
  }
  ::v-deep .el-table__cell {
    background: rgb(0, 10, 45) !important;
    // border: 1px solid rgb(0, 10, 45, 0.3) !important;
    // background-color: rgb(0, 10, 45);
    color: #fff !important;
  }
  ::v-deep .el-table__body-wrapper {
    overflow-x: auto !important; /* 淇濈暀婊氬姩鍔熻兘 */
    overflow-y: auto;

    /* 闅愯棌婊氬姩鏉′絾淇濈暀鍔熻兘 */
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      background: transparent;
      display: none;
    }

    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
  }
}
</style>




